import React, { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'
import format from 'date-fns/format'
import { parseISO } from 'date-fns'
import { recurringPaymentProxy } from '../../../../../../../../shared/proxies/recurringPaymentProxy'
import { PaymentResolveRadioSection } from './PaymentResolveRadioSection'

interface ResumeChargesSectionProps {
  isActive: boolean
}
export function ResumeChargesSection ({ isActive }: ResumeChargesSectionProps): ReactElement {
  const { recurringPayment } = useSnapshot(recurringPaymentProxy)

  const npd = recurringPayment?.nextPaymentDate

  //if the parent recurring payment is active, we want to hide this section...BC
  if (isActive) {
    return (
      <div className="mb-8">
        <p className="text-gray-600">
          This recurring charge is already active.
          <div>
            {npd &&
              <p>
                The next payment date is <span className="font-semibold"> {format(parseISO(npd), 'MMMM d, y')}</span>
              </p>}
          </div>
          Press 'Resolve' to mark this occurrence as resolved.
        </p>
      </div>
    )
  }

  return (
    <div>
      <div className="mb-8">
        <p className="text-gray-600">
          This recurring charged stopped on failure.  Set the next occurrence date to resume charges after a successful retry, or choose to keep it paused.
        </p>
      </div>
      <PaymentResolveRadioSection />
    </div>

  )
}
